module.exports = __webpack_public_path__ + "static/media/kafe-utu.04359183.jpeg";